<template>
  <div class="catalog-filter-mobile">
    <div class="catalog-filter-mobile__tabs">
      <button :class="{ 'catalog-filter-mobile__tab--active': activeTab === 'categories' }"
              class="catalog-filter-mobile__tab"
              @click="toggleTab('categories')"
      >
        <i class="uil-book-alt"></i> {{ $t('home.Categories') }}
        <i :class="activeTab === 'categories' ? 'uil-angle-up' : 'uil-angle-down'"
           class="catalog-filter-mobile__arrow"></i>
      </button>
      <button :class="{ 'catalog-filter-mobile__tab--active': activeTab === 'types' }"
              class="catalog-filter-mobile__tab"
              @click="toggleTab('types')"
      >
        <i class="uil-notes"></i> {{ $t('general.training_types') }}
        <i :class="activeTab === 'types' ? 'uil-angle-up' : 'uil-angle-down'" class="catalog-filter-mobile__arrow"></i>
      </button>
    </div>
    <div v-if="activeTab === 'categories'" class="catalog-filter-mobile__panel">
      <ul class="ks-cboxtags catalog-filter-mobile__list">
        <li v-for="(item, index) in categories" :key="'cat-m-' + index">
          <input :id="'checkboxCatM_' + index"
                 :checked="selectedCategories.includes(item.id)"
                 :value="item.id"
                 type="checkbox"
                 @change="handleCategoryChange($event, item.id)"
          >
          <label :for="'checkboxCatM_' + index">{{ item.name }}</label>
        </li>
      </ul>
    </div>
    <div v-if="activeTab === 'types'" class="catalog-filter-mobile__panel">
      <ul class="ks-cboxtags catalog-filter-mobile__list">
        <li>
          <input id="checkboxTypeOneM"
                 :checked="selectedTypes.includes(0)"
                 :value="0"
                 type="checkbox"
                 @change="handleTypeChange($event, 0)"
          >
          <label for="checkboxTypeOneM">{{ $t('general.all') }}</label>
        </li>
        <li v-for="(item, index) in types" :key="'kind-m-' + index">
          <input :id="'checkboxKindM_' + index"
                 :checked="selectedTypes.includes(item.id)"
                 :value="item.id"
                 type="checkbox"
                 @change="handleTypeChange($event, item.id)"
          >
          <label :for="'checkboxKindM_' + index">{{ item.name }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatalogFilterTabs",
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    },
    types: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedCategories: {
      type: Array,
      required: true,
      default: () => [0]
    },
    selectedTypes: {
      type: Array,
      required: true,
      default: () => [0]
    }
  },
  data() {
    return {
      activeTab: null
    };
  },
  methods: {
    toggleTab(tab) {
      this.activeTab = this.activeTab === tab ? null : tab;
    },
    handleCategoryChange(event, id) {
      const newCategories = [...this.selectedCategories];
      if (event.target.checked) {
        newCategories.push(id);
      } else {
        const index = newCategories.indexOf(id);
        if (index > -1) {
          newCategories.splice(index, 1);
        }
      }
      this.$emit('update:selectedCategories', newCategories);
    },
    handleTypeChange(event, id) {
      const newTypes = [...this.selectedTypes];
      if (event.target.checked) {
        newTypes.push(id);
      } else {
        const index = newTypes.indexOf(id);
        if (index > -1) {
          newTypes.splice(index, 1);
        }
      }
      this.$emit('update:selectedTypes', newTypes);
    }
  }
};
</script>

<style scoped>
/* ─── Base (hidden on desktop) ─── */
.catalog-filter-mobile {
  display: none;
}

@media (max-width: 959px) {
  .catalog-filter-mobile {
    display: block;
    margin-bottom: 12px;
  }
}

.catalog-filter-mobile__tabs {
  display: flex;
  gap: 0;
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 12px;
}

.catalog-filter-mobile__tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 48px;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  background: #fff;
  border: none;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s, color 0.15s;
}

.catalog-filter-mobile__tab:first-child {
  border-right: 1px solid #e2e8f0;
  border-radius: 12px 0 0 12px;
}

.catalog-filter-mobile__tab:last-child {
  border-radius: 0 12px 12px 0;
}

.catalog-filter-mobile__tab--active {
  color: #fff;
  background: var(--primaryColor, #3e416d);
}

/* Active tab'ın alt köşeleri panel açıkken düz olsun */
.catalog-filter-mobile__tab--active:first-child {
  border-radius: 12px 0 0 0;
}

.catalog-filter-mobile__tab--active:last-child {
  border-radius: 0 12px 0 0;
}

.catalog-filter-mobile__tab:active {
  opacity: 0.85;
}

.catalog-filter-mobile__arrow {
  font-size: 18px;
  margin-left: 2px;
}

.catalog-filter-mobile__panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 12px;
}

.catalog-filter-mobile__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.catalog-filter-mobile__list li {
  margin-bottom: 2px;
}

.catalog-filter-mobile__list li label {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 8px 12px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
}

.catalog-filter-mobile__list li label:active {
  background: #f1f5f9;
}

.catalog-filter-mobile__list li input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}

/* ─── Reduced motion ─── */
@media (prefers-reduced-motion: reduce) {
  .catalog-filter-mobile__tab {
    transition: none;
  }
}
</style>
